import {createProjectRfi$, deleteProjectRfi$, getProjectRfis$, updateProjectRfi$} from "../services/projects";
import {extractSubview} from "./view";
import {networkError} from "./ui";

export const ADD_RFIS = 'ADD_RFIS';
export const addRfis = (rfiList) => ({type: ADD_RFIS, payload: rfiList});
export const API_GET_RFIS = 'API_GET_RFIS';
export const getRfis = (projectId, offset) => ({type: API_GET_RFIS, payload: {projectId, offset}});
export const API_GET_RFIS_DONE = 'API_GET_RFIS_DONE';
export const getRfisDone = (response) => ({type: API_GET_RFIS_DONE, payload: response});
export const API_GET_RFI = 'API_GET_RFI';
export const getRfi = (projectId, id) => ({type: API_GET_RFI, payload: {projectId, id}});
export const API_GET_RFI_DONE = 'API_GET_RFI_DONE';
export const getRfiDone = (response, callback) => ({ type: API_GET_RFI_DONE, payload: { response, callback } });

export const createProjectRfi = (projectId, rfi, callback) => async (dispatch, getState) => {
  try {
    let { response, status } = await createProjectRfi$({ projectId, document: rfi }).toPromise();
    ({ response, status } = await getProjectRfis$({ id: response, projectId }).toPromise());
    dispatch(getRfiDone(response, callback));
  } catch (error) {
    dispatch(networkError({...error, number: '10128-'+error.status}));
  }
};

export const deleteProjectRfi = (projectId, rfiId) => async (dispatch, getState) => {
  try {
    let { response, status } = await deleteProjectRfi$({ projectId, subId: rfiId }).toPromise();
    dispatch(extractSubview([rfiId]));
  } catch (error) {
    dispatch(networkError({...error, number: '10129-'+error.status}));
  }
};

export const updateProjectRfi = (projectId, rfi) => async (dispatch, getState) => {
  try {
    let rfiId = rfi.id;
    let { response, status } = await updateProjectRfi$({ projectId, subId: rfiId, document: rfi }).toPromise();
    let { response: response2, status: status2 } = await getProjectRfis$({ projectId, id: rfiId }).toPromise();
    dispatch(getRfiDone(response2));
  } catch (error) {
    dispatch(networkError({...error, number: '10130-'+error.status}));
  }
};



// WEBPACK FOOTER //
// ./src/actions/rfis.js